import styled from 'styled-components';
import { Link as L } from 'react-router-dom';

export const Link = styled(L)`
  color: #000000;
`;